import { getTodoRequestHeaders } from 'owa-todo-service';
import { TODO_API_GET_SETTINGS } from '../utils/constants';
import {
    GetTodoSettingResponse,
    GetTodoSettingServiceResponse,
} from '../schema/GetTodoSettingServiceResponse';
import { makeGetRequest } from 'owa-ows-gateway';

export default async function getTodoSettingsService(): Promise<GetTodoSettingServiceResponse> {
    return makeGetRequest(
        TODO_API_GET_SETTINGS,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then(async (response: Response) => {
            const responseBody = <GetTodoSettingResponse>await response.json();

            return {
                StatusCode: response.status,
                ResponseBody: responseBody,
            };
        })
        .catch(err => {
            return null;
        });
}
